<template>
  <div
    class="box"
    style="width: 100%; height: 100%; min-width: 800px; min-height: 700px"
  >
    <div class="box row" style="width: 100%; min-height: 10%">
      <div class="box col" style="min-width: 40%; height: 100%">
        <img
          class="logo-img"
          style="
            float: left;
            margin-left: 10%;
            max-height: 100%;
            max-width: 80%;
          "
          :src="brand.header_logo"
        />
      </div>
      <div class="box col" style="min-width: 60%; height: 100%">
        <p class="box-title" style="font-style: italic; font-size: 20px">
          {{ program.canvas_config.problem_title }}
        </p>
        <button
          class="btn btn-no-border btn-si-green edit-button"
          v-tippy
          content="Edit"
          v-if="editable['problem'] && !editing['problem']"
        >
          <i class="fas fa-edit" @click="openEdit('problem')" />
        </button>
        <p
          class="box-icon fas fa-question"
          v-tippy
          :content="program.canvas_config.problem_desc"
        ></p>
        <p
          v-if="!editing['problem']"
          v-html="canvas.responses['problem']"
          class="response-text"
        ></p>

        <textarea
          v-if="editing['problem']"
          v-model="canvas.responses.problem"
          style="float: left; width: 90%"
        ></textarea>

        <button
          class="btn btn-primary"
          @click="closeEdit('problem')"
          v-if="editing['problem']"
        >
          Save
        </button>
      </div>
    </div>
    <div class="box row" style="width: 100%; height: 70%">
      <div id="partners" class="box col" style="width: 20%; height: 100%" click>
        <p
          class="box-title"
          :class="{
            'title-blue': editable['partners'],
            'title-gray': !editable['partners'],
          }"
        >
          {{ program.canvas_config.partners_title }}
        </p>
        <button
          class="btn btn-no-border btn-si-green edit-button"
          v-tippy
          content="Edit"
          v-if="editable['partners'] && !editing['partners']"
        >
          <i class="fas fa-edit" @click="openEdit('partners')" />
        </button>
        <p
          class="box-icon fas fa-handshake"
          v-tippy
          :content="program.canvas_config.partners_desc"
        ></p>
        <p
          v-if="!editing['partners']"
          v-html="canvas.responses['partners']"
          class="response-text"
        ></p>
        <div class="edit-box">
          <RichText
            v-if="editing['partners']"
            :text.sync="canvas.responses['partners']"
            :initial="initText['partners']"
            :options="{
              height: 208,
              toolbar: [
                [
                  'style',
                  ['bold', 'italic', 'underline', 'strikethrough', 'clear'],
                ],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link']],
              ],
            }"
          />
          <button class="btn" v-if="editing['partners']">
            <i
              v-if="canvas.attachments['partners'].link"
              class="fas fa-unlink"
              v-tippy
              content="Remove Attachment"
              @click="openRemoveAttachmentModal('partners')"
            />
            <i
              v-else
              class="fas fa-paperclip"
              v-tippy
              content="Attach File"
              @click="attachFile('partners')"
            />
          </button>
          <input
            ref="import"
            type="file"
            style="display: none"
            @change="onFilePicked"
          />
          <button
            class="btn btn-primary"
            @click="closeEdit('partners')"
            v-if="editing['partners']"
          >
            Save
          </button>
        </div>
        <button
          class="btn"
          v-tippy
          :content="canvas.attachments['partners'].filename"
          v-if="canvas.attachments['partners'].link"
          @click="downloadAttachment('partners')"
        >
          <i class="fas fa-file-download" />
          {{ canvas.attachments["partners"].filename }}
        </button>
      </div>
      <div class="box col" style="width: 20%; height: 100%">
        <div
          class="box row"
          style="width: 100%; min-height: 50%; border-width: 0px 0px 1px 0px"
        >
          <div id="activities" class="box col" style="border-width: 0px">
            <p
              class="box-title"
              :class="{
                'title-blue': editable['activities'],
                'title-gray': !editable['activities'],
              }"
            >
              {{ program.canvas_config.activities_title }}
            </p>
            <button
              class="btn btn-no-border btn-si-green edit-button"
              v-tippy
              content="Edit"
              v-if="editable['activities'] && !editing['activities']"
            >
              <i class="fas fa-edit" @click="openEdit('activities')" />
            </button>
            <p
              class="box-icon fas fa-puzzle-piece"
              v-tippy
              :content="program.canvas_config.activities_desc"
            ></p>
            <p
              v-if="!editing['activities']"
              v-html="canvas.responses['activities']"
              class="response-text"
            ></p>
            <div class="edit-box">
              <RichText
                v-if="editing['activities']"
                :text.sync="canvas.responses['activities']"
                :initial="initText['activities']"
                :options="{
                  height: 52,
                  toolbar: [
                    [
                      'style',
                      ['bold', 'italic', 'underline', 'strikethrough', 'clear'],
                    ],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['insert', ['link']],
                  ],
                }"
              />
              <button class="btn" v-if="editing['activities']">
                <i
                  v-if="canvas.attachments['activities'].link"
                  class="fas fa-unlink"
                  v-tippy
                  content="Remove Attachment"
                  @click="openRemoveAttachmentModal('activities')"
                />
                <i
                  v-else
                  class="fas fa-paperclip"
                  v-tippy
                  content="Attach File"
                  @click="attachFile('activities')"
                />
              </button>
              <input
                ref="import"
                type="file"
                style="display: none"
                @change="onFilePicked"
              />
              <button
                class="btn btn-primary"
                @click="closeEdit('activities')"
                v-if="editing['activities']"
              >
                Save
              </button>
            </div>
            <button
              class="btn"
              v-tippy
              :content="canvas.attachments['activities'].filename"
              v-if="canvas.attachments['activities'].link"
              @click="downloadAttachment('activities')"
            >
              <i class="fas fa-file-download" />
              {{ canvas.attachments["activities"].filename }}
            </button>
          </div>
        </div>
        <div
          class="box row"
          style="width: 100%; min-height: 50%; border-width: 0px"
        >
          <div id="resources" class="box col" style="border-width: 0px">
            <p
              class="box-title"
              :class="{
                'title-blue': editable['resources'],
                'title-gray': !editable['resources'],
              }"
            >
              {{ program.canvas_config.resources_title }}
            </p>
            <button
              class="btn btn-no-border btn-si-green edit-button"
              v-tippy
              content="Edit"
              v-if="editable['resources'] && !editing['resources']"
            >
              <i class="fas fa-edit" @click="openEdit('resources')" />
            </button>
            <p
              class="box-icon fas fa-globe-americas"
              v-tippy
              :content="program.canvas_config.resources_desc"
            ></p>
            <p
              v-if="!editing['resources']"
              v-html="canvas.responses['resources']"
              class="response-text"
            ></p>

            <div class="edit-box">
              <RichText
                v-if="editing['resources']"
                :text.sync="canvas.responses['resources']"
                :initial="initText['resources']"
                :options="{
                  height: 52,
                  toolbar: [
                    [
                      'style',
                      ['bold', 'italic', 'underline', 'strikethrough', 'clear'],
                    ],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['insert', ['link']],
                  ],
                }"
              />
              <button class="btn" v-if="editing['resources']">
                <i
                  v-if="canvas.attachments['resources'].link"
                  class="fas fa-unlink"
                  v-tippy
                  content="Remove Attachment"
                  @click="openRemoveAttachmentModal('resources')"
                />
                <i
                  v-else
                  class="fas fa-paperclip"
                  v-tippy
                  content="Attach File"
                  @click="attachFile('resources')"
                />
              </button>
              <input
                ref="import"
                type="file"
                style="display: none"
                @change="onFilePicked"
              />
              <button
                class="btn btn-primary"
                @click="closeEdit('resources')"
                v-if="editing['resources']"
              >
                Save
              </button>
            </div>
            <button
              class="btn"
              v-tippy
              :content="canvas.attachments['resources'].filename"
              v-if="canvas.attachments['resources'].link"
              @click="downloadAttachment('resources')"
            >
              <i class="fas fa-file-download" />
              {{ canvas.attachments["resources"].filename }}
            </button>
          </div>
        </div>
      </div>
      <div id="values" class="box col" style="width: 20%; height: 100%">
        <p
          class="box-title"
          :class="{
            'title-blue': editable['values'],
            'title-gray': !editable['values'],
          }"
        >
          {{ program.canvas_config.value_title }}
        </p>
        <button
          class="btn btn-no-border btn-si-green edit-button"
          v-tippy
          content="Edit"
          v-if="editable['values'] && !editing['values']"
        >
          <i class="fas fa-edit" @click="openEdit('values')" />
        </button>
        <p
          class="box-icon fas fa-lightbulb"
          v-tippy
          :content="program.canvas_config.value_desc"
        ></p>

        <p
          v-if="!editing['values']"
          v-html="canvas.responses['values']"
          class="response-text"
        ></p>

        <div class="edit-box">
          <RichText
            v-if="editing['values']"
            :text.sync="canvas.responses['values']"
            :initial="initText['values']"
            :options="{
              height: 208,
              toolbar: [
                [
                  'style',
                  ['bold', 'italic', 'underline', 'strikethrough', 'clear'],
                ],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link']],
              ],
            }"
          />
          <button class="btn" v-if="editing['values']">
            <i
              v-if="canvas.attachments['values'].link"
              class="fas fa-unlink"
              v-tippy
              content="Remove Attachment"
              @click="openRemoveAttachmentModal('values')"
            />
            <i
              v-else
              class="fas fa-paperclip"
              v-tippy
              content="Attach File"
              @click="attachFile('values')"
            />
          </button>
          <input
            ref="import"
            type="file"
            style="display: none"
            @change="onFilePicked"
          />
          <button
            class="btn btn-primary"
            @click="closeEdit('values')"
            v-if="editing['values']"
          >
            Save
          </button>
        </div>
        <button
          class="btn"
          v-tippy
          :content="canvas.attachments['values'].filename"
          v-if="canvas.attachments['values'].link"
          @click="downloadAttachment('values')"
        >
          <i class="fas fa-file-download" />
          {{ canvas.attachments["values"].filename }}
        </button>
      </div>
      <div class="box col" style="width: 20%; height: 100%">
        <div
          class="box row"
          style="width: 100%; min-height: 50%; border-width: 0px 0px 1px 0px"
        >
          <div id="relationships" class="box col" style="border-width: 0px">
            <p
              class="box-title"
              :class="{
                'title-blue': editable['relationships'],
                'title-gray': !editable['relationships'],
              }"
            >
              {{ program.canvas_config.relationships_title }}
            </p>
            <button
              class="btn btn-no-border btn-si-green edit-button"
              v-tippy
              content="Edit"
              v-if="editable['relationships'] && !editing['relationships']"
            >
              <i class="fas fa-edit" @click="openEdit('relationships')" />
            </button>
            <p
              class="box-icon fas fa-infinity"
              v-tippy
              :content="program.canvas_config.relationships_desc"
            ></p>

            <p
              v-if="!editing['relationships']"
              v-html="canvas.responses['relationships']"
              class="response-text"
            ></p>
            <div class="edit-box">
              <RichText
                v-if="editing['relationships']"
                :text.sync="canvas.responses['relationships']"
                :initial="initText['relationships']"
                :options="{
                  height: 52,
                  toolbar: [
                    [
                      'style',
                      ['bold', 'italic', 'underline', 'strikethrough', 'clear'],
                    ],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['insert', ['link']],
                  ],
                }"
              />
              <button class="btn" v-if="editing['relationships']">
                <i
                  v-if="canvas.attachments['relationships'].link"
                  class="fas fa-unlink"
                  v-tippy
                  content="Remove Attachment"
                  @click="openRemoveAttachmentModal('relationships')"
                />
                <i
                  v-else
                  class="fas fa-paperclip"
                  v-tippy
                  content="Attach File"
                  @click="attachFile('relationships')"
                />
              </button>
              <input
                ref="import"
                type="file"
                style="display: none"
                @change="onFilePicked"
              />
              <button
                class="btn btn-primary"
                @click="closeEdit('relationships')"
                v-if="editing['relationships']"
              >
                Save
              </button>
            </div>
            <button
              class="btn"
              v-tippy
              :content="canvas.attachments['relationships'].filename"
              v-if="canvas.attachments['relationships'].link"
              @click="downloadAttachment('relationships')"
            >
              <i class="fas fa-file-download" />
              {{ canvas.attachments["relationships"].filename }}
            </button>
          </div>
        </div>
        <div
          class="box row"
          style="width: 100%; min-height: 50%; border-width: 0px"
        >
          <div id="channels" class="box col" style="border-width: 0px">
            <p
              class="box-title"
              :class="{
                'title-blue': editable['channels'],
                'title-gray': !editable['channels'],
              }"
            >
              {{ program.canvas_config.channels_title }}
            </p>
            <button
              class="btn btn-no-border btn-si-green edit-button"
              v-tippy
              content="Edit"
              v-if="editable['channels'] && !editing['channels']"
            >
              <i class="fas fa-edit" @click="openEdit('channels')" />
            </button>
            <p
              class="box-icon fas fa-map-signs"
              v-tippy
              :content="program.canvas_config.channels_desc"
            ></p>

            <p
              v-if="!editing['channels']"
              v-html="canvas.responses['channels']"
              class="response-text"
            ></p>

            <div class="edit-box">
              <RichText
                v-if="editing['channels']"
                :text.sync="canvas.responses['channels']"
                :initial="initText['channels']"
                :options="{
                  height: 52,
                  toolbar: [
                    [
                      'style',
                      ['bold', 'italic', 'underline', 'strikethrough', 'clear'],
                    ],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['insert', ['link']],
                  ],
                }"
              />
              <button class="btn" v-if="editing['channels']">
                <i
                  v-if="canvas.attachments['channels'].link"
                  class="fas fa-unlink"
                  v-tippy
                  content="Remove Attachment"
                  @click="openRemoveAttachmentModal('channels')"
                />
                <i
                  v-else
                  class="fas fa-paperclip"
                  v-tippy
                  content="Attach File"
                  @click="attachFile('channels')"
                />
              </button>
              <input
                ref="import"
                type="file"
                style="display: none"
                @change="onFilePicked"
              />
              <button
                class="btn btn-primary"
                @click="closeEdit('channels')"
                v-if="editing['channels']"
              >
                Save
              </button>
            </div>
            <button
              class="btn"
              v-tippy
              :content="canvas.attachments['channels'].filename"
              v-if="canvas.attachments['channels'].link"
              @click="downloadAttachment('channels')"
            >
              <i class="fas fa-file-download" />
              {{ canvas.attachments["channels"].filename }}
            </button>
          </div>
        </div>
      </div>
      <div class="box col" style="width: 20%; height: 100%">
        <div
          class="box row"
          style="width: 100%; min-height: 30%; border-width: 0px 0px 1px 0px"
        >
          <div id="segments" class="box col" style="border-width: 0px">
            <p
              class="box-title"
              :class="{
                'title-blue': editable['segments'],
                'title-gray': !editable['segments'],
              }"
            >
              {{ program.canvas_config.segments_title }}
            </p>
            <button
              class="btn btn-no-border btn-si-green edit-button"
              v-tippy
              content="Edit"
              v-if="editable['segments'] && !editing['segments']"
            >
              <i class="fas fa-edit" @click="openEdit('segments')" />
            </button>
            <p
              class="box-icon fas fa-users"
              v-tippy
              :content="program.canvas_config.segments_desc"
            ></p>
            <p
              v-if="!editing['segments']"
              v-html="canvas.responses['segments']"
              class="response-text"
            ></p>

            <div class="edit-box">
              <RichText
                v-if="editing['segments']"
                :text.sync="canvas.responses['segments']"
                :initial="initText['segments']"
                :options="{
                  height: 52,
                  toolbar: [
                    [
                      'style',
                      ['bold', 'italic', 'underline', 'strikethrough', 'clear'],
                    ],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['insert', ['link']],
                  ],
                }"
              />
              <button class="btn" v-if="editing['segments']">
                <i
                  v-if="canvas.attachments['segments'].link"
                  class="fas fa-unlink"
                  v-tippy
                  content="Remove Attachment"
                  @click="openRemoveAttachmentModal('segments')"
                />
                <i
                  v-else
                  class="fas fa-paperclip"
                  v-tippy
                  content="Attach File"
                  @click="attachFile('segments')"
                />
              </button>
              <input
                ref="import"
                type="file"
                style="display: none"
                @change="onFilePicked"
              />
              <button
                class="btn btn-primary"
                @click="closeEdit('segments')"
                v-if="editing['segments']"
              >
                Save
              </button>
            </div>
            <button
              class="btn"
              v-tippy
              :content="canvas.attachments['segments'].filename"
              v-if="canvas.attachments['segments'].link"
              @click="downloadAttachment('segments')"
            >
              <i class="fas fa-file-download" />
              {{ canvas.attachments["segments"].filename }}
            </button>
          </div>
        </div>
        <div
          class="box row"
          style="width: 100%; min-height: 70%; border-width: 0px"
        >
          <div id="discovery" class="box col" style="border-width: 0px">
            <p
              class="box-title"
              :class="{
                'title-blue': editable['discovery'],
                'title-gray': !editable['discovery'],
              }"
            >
              {{ program.canvas_config.discovery_title }}
            </p>
            <button
              class="btn btn-no-border btn-si-green edit-button"
              v-tippy
              content="Edit"
              v-if="editable['discovery'] && !editing['discovery']"
            >
              <i class="fas fa-edit" @click="openEdit('discovery')" />
            </button>
            <p
              class="box-icon fas fa-binoculars"
              v-tippy
              :content="program.canvas_config.discovery_desc"
            ></p>
            <p
              v-if="!editing['discovery']"
              v-html="canvas.responses['discovery']"
              class="response-text"
            ></p>

            <div class="edit-box">
              <RichText
                v-if="editing['discovery']"
                :text.sync="canvas.responses['discovery']"
                :initial="initText['discovery']"
                :options="{
                  height: 52,
                  toolbar: [
                    [
                      'style',
                      ['bold', 'italic', 'underline', 'strikethrough', 'clear'],
                    ],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['insert', ['link']],
                  ],
                }"
              />
              <button class="btn" v-if="editing['discovery']">
                <i
                  v-if="canvas.attachments['discovery'].link"
                  class="fas fa-unlink"
                  v-tippy
                  content="Remove Attachment"
                  @click="openRemoveAttachmentModal('discovery')"
                />
                <i
                  v-else
                  class="fas fa-paperclip"
                  v-tippy
                  content="Attach File"
                  @click="attachFile('discovery')"
                />
              </button>
              <input
                ref="import"
                type="file"
                style="display: none"
                @change="onFilePicked"
              />
              <button
                class="btn btn-primary"
                @click="closeEdit('discovery')"
                v-if="editing['discovery']"
              >
                Save
              </button>
            </div>
            <button
              class="btn"
              v-tippy
              :content="canvas.attachments['discovery'].filename"
              v-if="canvas.attachments['discovery'].link"
              @click="downloadAttachment('discovery')"
            >
              <i class="fas fa-file-download" />
              {{ canvas.attachments["discovery"].filename }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="box row" style="width: 100%; height: 20%">
      <div class="box col" style="width: 50%; min-height: 100%">
        <p
          class="box-title"
          :class="{
            'title-green': editable['cost'],
            'title-gray': !editable['cost'],
          }"
        >
          {{ program.canvas_config.cost_title }}
        </p>
        <button
          class="btn btn-no-border btn-si-green edit-button"
          v-tippy
          content="Edit"
          v-if="editable['cost'] && !editing['cost']"
        >
          <i class="fas fa-edit" @click="openEdit('cost')" />
        </button>
        <p
          class="box-icon fas fa-calculator"
          v-tippy
          :content="program.canvas_config.cost_desc"
        ></p>
        <p
          v-if="!editing['cost']"
          v-html="canvas.responses['cost']"
          class="response-text"
        ></p>

        <div class="edit-box">
          <RichText
            style="float: left"
            v-if="editing['cost']"
            :text.sync="canvas.responses['cost']"
            :initial="initText['cost']"
            :options="{
              height: 52,
              toolbar: [
                [
                  'style',
                  ['bold', 'italic', 'underline', 'strikethrough', 'clear'],
                ],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link']],
              ],
            }"
          />
          <button class="btn" v-if="editing['cost']">
            <i
              v-if="canvas.attachments['cost'].link"
              class="fas fa-unlink"
              v-tippy
              content="Remove Attachment"
              @click="openRemoveAttachmentModal('cost')"
            />
            <i
              v-else
              class="fas fa-paperclip"
              v-tippy
              content="Attach File"
              @click="attachFile('cost')"
            />
          </button>
          <input
            ref="import"
            type="file"
            style="display: none"
            @change="onFilePicked"
          />
          <button
            class="btn btn-primary"
            @click="closeEdit('cost')"
            v-if="editing['cost']"
          >
            Save
          </button>
        </div>
        <button
          class="btn"
          v-tippy
          :content="canvas.attachments['cost'].filename"
          v-if="canvas.attachments['cost'].link"
          @click="downloadAttachment('cost')"
        >
          <i class="fas fa-file-download" />
          {{ canvas.attachments["cost"].filename }}
        </button>
      </div>
      <div class="box col" style="width: 50%; min-height: 100%">
        <p
          class="box-title"
          :class="{
            'title-green': editable['revenue'],
            'title-gray': !editable['revenue'],
          }"
        >
          {{ program.canvas_config.revenue_title }}
        </p>
        <button
          class="btn btn-no-border btn-si-green edit-button"
          v-tippy
          content="Edit"
          v-if="editable['revenue'] && !editing['revenue']"
        >
          <i class="fas fa-edit" @click="openEdit('revenue')" />
        </button>
        <p
          class="box-icon fas fa-file-invoice-dollar"
          v-tippy
          :content="program.canvas_config.revenue_desc"
        ></p>
        <p
          v-if="!editing['revenue']"
          v-html="canvas.responses['revenue']"
          class="response-text"
        ></p>

        <div class="edit-box">
          <RichText
            style="float: left"
            v-if="editing['revenue']"
            :text.sync="canvas.responses['revenue']"
            :initial="initText['revenue']"
            :options="{
              height: 52,
              toolbar: [
                [
                  'style',
                  ['bold', 'italic', 'underline', 'strikethrough', 'clear'],
                ],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link']],
              ],
            }"
          />
          <button class="btn" v-if="editing['revenue']">
            <i
              v-if="canvas.attachments['revenue'].link"
              class="fas fa-unlink"
              v-tippy
              content="Remove Attachment"
              @click="openRemoveAttachmentModal('revenue')"
            />
            <i
              v-else
              class="fas fa-paperclip"
              v-tippy
              content="Attach File"
              @click="attachFile('revenue')"
            />
          </button>
          <input
            ref="import"
            type="file"
            style="display: none"
            @change="onFilePicked"
          />
          <button
            class="btn btn-primary"
            @click="closeEdit('revenue')"
            v-if="editing['revenue']"
          >
            Save
          </button>
        </div>
        <button
          class="btn"
          v-tippy
          :content="canvas.attachments['revenue'].filename"
          v-if="canvas.attachments['revenue'].link"
          @click="downloadAttachment('revenue')"
        >
          <i class="fas fa-file-download" />
          {{ canvas.attachments["revenue"].filename }}
        </button>
      </div>
    </div>
    <b-modal
      id="lockReleaseModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <template v-slot:modal-title>
        <h3 class="modal-title full-bar-title">Are you still editing?</h3>
      </template>
      <div class="p-2">
        <p>
          You have held a lock on one or more cells for more than 5 minutes.
        </p>
        <p>
          Click "keep locks" to continue editing or "save and release" to open
          cells to editing by teammates.
        </p>
        <p>
          If you do nothing, your work will be saved and locks will be released
          in {{ timeout2 }} seconds.
        </p>
      </div>
      <template v-slot:modal-footer>
        <button type="button" class="btn btn-secondary" @click="resetTimeout">
          Keep Locks
        </button>
        <button type="button" class="btn btn-primary" @click="releaseLocks">
          Save and Release
        </button>
      </template>
    </b-modal>
    <b-modal id="deleteAttachmentModal" headerClass="indigo">
      <template v-slot:modal-title>
        <h3 class="modal-title full-bar-title">Delete Attachment</h3>
      </template>
      <div v-if="deletingTopic" class="p-2">
        <div class="row px-4 py-2 text-md">
          <div class="py-2">
            <h5 class="text-danger far faw fa-exclamation-triangle">
              Are you sure you want to permanently delete this attached file?
            </h5>
            <br />
            <p>{{ canvas.attachments[deletingTopic].filename }}</p>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <button type="button" class="btn btn-secondary" @click="cancel">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="removeAttachment(deletingTopic)"
        >
          Delete
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import BrandService from "@/services/BrandService";
import RichText from "@/components/RichText";
import CanvasService from "@/services/CanvasService";
import Notie from "@/services/NotieService";

export default {
  name: "CanvasEditor",
  props: ["canEdit", "canvasData", "user", "team", "program"],
  components: { RichText },

  data() {
    return {
      brand: BrandService.getBrand(),

      editing: null,
      initText: null,
      canvas: null,
      timeout: null,
      timeout2: null,
      attachTopic: null,
      deletingTopic: null,
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    editable() {
      var editable = {};

      for (var key of Object.keys(this.editing)) {
        editable[key] =
          this.canEdit &&
          (this.canvas.locks[key].lock_holder == this.user.id ||
            this.canvas.locks[key].locked == false);
      }
      return editable;
    },
  },

  methods: {
    loadData() {
      this.editing = {
        problem: false,
        partners: false,
        activities: false,
        resources: false,
        values: false,
        relationships: false,
        channels: false,
        segments: false,
        discovery: false,
        cost: false,
        revenue: false,
      };
      this.initText = {
        problem: "",
        partners: "",
        activities: "",
        resources: "",
        values: "",
        relationships: "",
        channels: "",
        segments: "",
        discovery: "",
        cost: "",
        revenue: "",
      };

      if (
        !this.program.canvas_config.problem_title ||
        this.program.canvas_config.problem_title == ""
      ) {
        this.program.canvas_config.problem_title = "Define the Problem";
      }
      if (
        !this.program.canvas_config.problem_desc ||
        this.program.canvas_config.problem_desc == ""
      ) {
        this.program.canvas_config.problem_desc =
          "State the problem you are investigating. What is the root cause of the problem?";
      }

      this.canvas = this.canvasData;
      CanvasService.saveCanvas(this.canvas)
        .then((r) => {
          console.log("SAVE CANVAS", r);
          this.canvas.id = r.data.id;
        })
        .catch((e) => {
          console.log(e);
        });

      //open edit on cells where I have lock
      for (var id of Object.keys(this.canvas.locks)) {
        if (
          this.canvas.locks[id].lock_holder == this.user.id &&
          this.canvas.locks[id].locked
        ) {
          this.initText[id] = this.canvas.responses[id];
          this.editing[id] = true;
        }
      }
    },
    openEdit(id) {
      this.initText[id] = this.canvas.responses[id];
      this.editing[id] = true;
      CanvasService.getCanvas(this.canvas.id)
        .then((r) => {
          this.canvas = r.data;

          console.log(this.canvas.locks[id].lock_holder);

          if (
            this.canvas.locks[id].lock_holder == this.user.id &&
            this.canvas.locks[id].locked
          ) {
            //already have lock
            this.editing[id] = true;
          } else if (!this.canvas.locks[id].locked) {
            //no locks -- set lock
            this.canvas.locks[id].locked = true;
            this.canvas.locks[id].lock_holder = this.user.id;
            console.log(this.canvas);
            CanvasService.saveCanvas(this.canvas)
              .then((r) => {
                console.log(r);
                this.editing[id] = true;
                this.resetTimeout();
              })
              .catch((e) => {
                Notie.error("Failed to get lock", e);
                this.editing[id] = false;
                //undo changes
                this.canvas.responses[id] = this.initText[id];
              });
          } else {
            Notie.error("One of your teammates is already editing this cell");
            this.editing[id] = false;

            //undo changes
            this.canvas.responses[id] = this.initText[id];
          }
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Error loading canvas data", e);
          this.editing[id] = false;

          //undo changes
          this.canvas.responses[id] = this.initText[id];
        });
    },

    closeEdit(id) {
      this.editing[id] = false;
      this.canvas.locks[id].locked = false;

      CanvasService.saveCanvas(this.canvas)
        .then((r) => {
          console.log(r);
          Notie.success("Changes saved");
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Error saving canvas", e);
        });

      this.resetTimeout();
    },

    resetTimeout() {
      this.$bvModal.hide("lockReleaseModal");

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout2 = -1;

      //set timer if user is editing
      for (var id of Object.keys(this.editing)) {
        if (this.editing[id]) {
          this.timeout = setTimeout(this.timeoutFunc, 5 * 60 * 1000);
          return;
        }
      }
    },

    timeoutFunc() {
      this.$bvModal.show("lockReleaseModal");
      this.timeout2 = 20;
      this.countdown();
    },

    countdown() {
      if (this.timeout2 == 0) {
        this.releaseLocks();
      } else if (this.timeout2 > 0) {
        this.timeout2 -= 1;
        setTimeout(this.countdown, 1000);
      }
    },

    releaseLocks() {
      for (var id of Object.keys(this.editing)) {
        this.editing[id] = false;
        this.canvas.locks[id].locked = false;
      }

      CanvasService.saveCanvas(this.canvas)
        .then((r) => {
          console.log(r);
          Notie.success("Changes saved");
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Error saving canvas", e);
        });

      this.resetTimeout();
    },

    attachFile(topic) {
      this.attachTopic = topic;
      this.$refs.import.click();
    },
    downloadAttachment(topic) {
      console.log("download", topic);
      CanvasService.getAttachment(
        this.canvas.team_id,
        this.canvas.assignment_id,
        topic
      )
        .then((resp) => {
          console.log(resp);
          var a = document.createElement("a");
          a.href = resp.data;
          a.download = "download";
          a.target = "_blank";
          a.click();
        })
        .catch((e) => {
          Notie.error("Failed to get file", e);
        });
    },
    openRemoveAttachmentModal(topic) {
      this.deletingTopic = topic;
      this.$bvModal.show("deleteAttachmentModal");
    },
    removeAttachment(topic) {
      CanvasService.removeAttachment(
        this.canvas.team_id,
        this.canvas.assignment_id,
        topic
      )
        .then(() => {
          Notie.success("Successfully deleted file");
          this.canvas.attachments[topic] = {};
          this.$bvModal.hide("deleteAttachmentModal");
        })
        .catch((e) => {
          Notie.error("Failed to delete file", e);
        });
    },
    onFilePicked(event) {
      console.log("FILES", event.target.files[0]);
      const fileReader = new FileReader();
      let file = event.target.files[0];
      fileReader.readAsArrayBuffer(file);
      console.log(file);
      let canvas = this.canvas;
      let topic = this.attachTopic;
      fileReader.onload = function () {
        console.log(fileReader.result);
        let buffer = new Uint8Array(fileReader.result);
        let byteArr = [];
        for (var i = 0; i < file.size; i++) {
          byteArr.push(buffer[i]);
        }
        CanvasService.attachFile(canvas.team_id, canvas.assignment_id, topic, {
          content: byteArr,
          size: file.size,
          name: file.name,
        })
          .then((resp) => {
            Notie.success("Successfully uploaded file");
            canvas.attachments[topic] = resp.data;
          })
          .catch((e) => {
            Notie.error("Failed to upload file", e);
          });
      };
    },
  },
};
</script>

<style scoped>
.box {
  border-style: solid;
  border-width: 1px;
  position: relative;
  margin: 0px;
  padding: 0px;
}
.box .row {
  border-width: 1px 0px;
}
.box .col {
  border-width: 0px 1px;
}
.edit-box {
  z-index: 10;
  position: relative;
}
.box-title {
  float: left;
  text-align: left;
  margin: 0px 0px 0px 5px;
  width: calc(100% - 70px);
  font-size: 17px;
  font-style: italic;
  padding: 0px;
}
.title-blue {
  color: #000080;
}
.title-green {
  color: #008000;
}
.title-gray {
  color: #444444;
}
.box-icon {
  margin: 5px;
  font-size: 25px;
}
.response-text {
  word-break: break-word;
  margin: 10px 20px;
  float: left;
}
.edit-button {
  height: 20px;
  width: 20px;
  font-size: 10px;
  padding: 0;
}
</style>